export class AppRouteConstants {
  public static readonly LogsList = '/jobs/logs';
  public static readonly LogDetails = '/jobs/logs/:id';
  public static readonly LogPrint = '/jobs/logs/:id/print';

  public static readonly BundlesList = '/jobs/bundles';
  public static readonly BundleDetails = '/jobs/bundles/:id';
  public static readonly BundleInstructions = '/jobs/bundles-instructions';
}
